<template>
  <zen-one :showuserinfo="false" title="" :crumbs="crumbs">
	  <z-page title="Pengeluaran Semen Beku">
      <div class="table_scrol">
        <div class="w-card__content content-hardcode mb3">
          <w-form v-model="valid" @validate="cari" ref="frm">
            <w-flex class="mt4">
              <div class="xs6">
                <div class="spacer"></div>
                <div class="spacer"></div>
                 <w-input style="margin:5px; "
                 v-model="pencarian.no_batch"
                 label="No. Batch"
                 />
              </div>
              <div class="xs4">
                <div class="spacer"></div>
                 <z-select style="margin:5px; "
                 v-model="pencarian.se_katalog_id"
                 :items="se_katalog"
                 label="ID | Nama Ternakan"
                 />
              </div>
              <div class="xs4">
                 <z-select style="margin:5px; "
                 v-model="pencarian.lkp_status_id"
                 :items="status"
                 label="Status"
                 />
              </div>
            </w-flex>
          </w-form>

          <w-flex justify-end class="mt2">
                      <w-button bg-color="success" v-on="on" @click="cetak()" class="mr2">
                    <w-icon class="mr1" md >fal fa-print</w-icon>CETAK
                </w-button>
                      <w-button class="mr2" v-on:click="resetPencarian()" v-on="on" bg-color="warning">
                    <w-icon class="mr1" md >fal fa-redo</w-icon>SET SEMULA
                </w-button>
                      <w-button class="mr2" bg-color="primary"  v-on="on" @click="$refs.frm.validate()">
                    <w-icon class="mr1" md >fal fa-search</w-icon>CARI
                </w-button>
          </w-flex>
        </div>
  		  <z-table title="Senarai Pengeluaran Semen Beku" :headers="table.headers" :items="table.items" :meta="table.meta">
            <template #button  v-if="$zutil.anyRole(['1', '3', '11'])">
                      <inertia-link :href="$route('se.pengeluaran.form',0)" v-on="on" class="w-button green--bg  w-button--dark size--md  ml1">
                    <w-icon class="mr1" md >fal fa-plus</w-icon>TAMBAH
                </inertia-link>
            </template>
  		    <template #header-label="{ header, label, index }">
  		      <template v-if="header.key == 'action'">
  			     <!--  <w-icon xs>fal fa-pencil</w-icon> -->
             TINDAKAN
            </template>
  		      <template v-else>
  		      	{{ label }}
  		      </template>
  		    </template>
  		    <template #item-cell.action="{ item, label, header, index }">
  		      <w-flex class="flex justify-center">
               <w-tooltip md top color="white" bg-color="black" >
                <template #activator="{ on }">
                      <inertia-link :href="$route('se.pengeluaran.show',item.id)" v-on="on" class="w-button w-button--dark size--md info-dark1--bg"><div style="width: 6px"></div> 
                    <w-icon class="mr1" md >fal fa-eye</w-icon>
                </inertia-link>
                </template>
               PAPAR
            </w-tooltip>
                 &nbsp;
            <w-tooltip md top color="white" bg-color="black" >
                <template #activator="{ on }">
                      <w-button  bg-color="warning" v-on="on" v-if="item.hantar!=1 && ($zutil.anyRole(['1', '3', '11']))" :route="$route('se.pengeluaran.form',item.id)" class="be fs-2"><div style="width: 6px"></div> 
                    <w-icon class="mr1" md >fal fa-pencil</w-icon>
                </w-button>
                </template>
               KEMASKINI
            </w-tooltip>
                    &nbsp;
            <w-tooltip md top color="white" bg-color="black" >
                <template #activator="{ on }">
                      <w-button class="fs-2" v-on="on" v-if="item.pendaftar==0 && ($zutil.anyRole(['1', '3', '11']))" bg-color="error-dark1" dark tile @click="destroy1(item.id)"><div style="width: 6px"></div> 
                    <w-icon class="mr1" md >fal fa-trash</w-icon>
                </w-button>
                </template>
               PADAM
            </w-tooltip>
         </w-flex>
  		    </template>
           <template #item-cell.tarikh="{ item, label, header, index }">
              <w-flex class="flex justify-light">
                 {{ $zutil.dateformat(item.tarikh)}}
              </w-flex>
           </template>
  		  </z-table>
      </div>
	  </z-page>
  </zen-one>
</template>

<script>
import { reactive } from 'vue'
import ZResource from '@/Modules/z-resource'

export default {
  extends: ZResource,
  props: {
    items: [Array, Object],
  },
  data() {
    return {
      resourceurl: 'se.pengeluaran',
      crumbs: [
        { label: this.$page.props.app_name, route: '/home' },
        { label: 'Pengurusan Semen Beku', route: '/se' },
        { label: 'Pengeluaran Semen Beku', route: '/se/pengeluaran' },
      ],
      pencarian: {
         no_batch: '',
         se_katalog_id: '',
         lkp_status_id: ''
      },
      se_katalog: [],
      status: [],
      
    }
  },
  methods: {
   cari() {
      if(!this.valid) return;

      let params = {
      ...this.pencarian,
      };
      params.page = 1;
      params.per_page =9999; 
      this.$inertia.visit(route(route().current(), params), {
           preserveState: true,
           preserveScroll: true,
      });
   },
   resetPencarian() {
      this.$inertia.visit(route(route().current()));
   },
   getKatalog(){
      this.$zcomm.get(this.api_service + 'lookup/id_ternakan_se', {}).then(res => {
        this.se_katalog = res
      })
   },
   getStatus(){
      this.$zcomm.get(this.api_service + 'lookup/status_mp', {}).then(res => {
         this.status = res
      })
   },
   cetak() {
      window.location.href = window.route('se.pengeluaran.index')+'?se_katalog_id='+this.pencarian.se_katalog_id+'&no_batch='+this.pencarian.no_batch+'&lkp_status_id='+this.pencarian.lkp_status_id+'&cetak=1';
    },
   destroy1(id)
    {
      this.$swal({
        title: 'Anda Pasti?',
        // text: "Are you sure want to delete this item!",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ya',
        cancelButtonText: 'Tidak'
      }).then((result) => {
        if (result.value) {
          this.$zcomm.delete(this.resourceurl + '.destroy',id)
          .then(res => {
            this.sending = false;
            this.$inertia.visit(this.$page.url)
            this.removeitem(res) // remove the data from list. no need to refresh page
            if (typeof this.onAfterDelete === "function") {
              this.onAfterDelete()
            }
          })
          .finally(() => {
            // $('#' + this.resourceurl).modal('hide')
          });
        }else{ }
        })

    },
   
  },

  watch: {

  },
  mounted() {
   this.getKatalog();
   this.getStatus();
    // override default setting
    this.dialog.width = 500
      
  },
}
</script>
